// src/utils/tournamentLogic.js

// Función para obtener el nombre de la ronda (Final, Semifinales, etc.)
export const getPhaseName = (phaseIdx, totalPlayers) => {
  if (totalPlayers < 2) return '';
  const totalRounds = Math.ceil(Math.log2(2 ** Math.ceil(Math.log2(totalPlayers))));
  const roundsFromFinal = totalRounds - 1 - phaseIdx;

  switch (roundsFromFinal) {
    case 0: return 'Final';
    case 1: return 'Semifinales';
    case 2: return 'Cuartos de Final';
    case 3: return 'Octavos de Final';
    case 4: return 'Ronda de 32';
    default: return `Ronda ${phaseIdx + 1}`;
  }
};

// ✅ FUNCIÓN AÑADIDA
// Función para obtener las etiquetas de puntos (Campeón, Finalista, etc.)
export const getRoundLabelsForPoints = (totalPlayers) => {
  const labels = {
    winner: 'Campeón',
    finalist: 'Finalista',
    semiFinalist: 'Semifinalista',
  };

  if (totalPlayers >= 8) {
    labels.quarterFinalist = 'Cuartofinalista';
  }
  if (totalPlayers >= 16) {
    labels.roundOf16 = 'Octavos de Final';
  }
  if (totalPlayers >= 32) {
    labels.roundOf32 = 'Ronda de 32';
  }
  
  return labels;
};